export default function (node) {
  const focusable = node.querySelectorAll(
    'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="search"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
  )
  const firstFocusableNode = focusable[0]
  const lastFocusableNode = focusable[focusable.length - 1]

  node.addEventListener('keydown', function (e) {
    const isTabPressed = e.key === 'Tab' || e.keyCode === 9

    if (!isTabPressed) return

    if (e.shiftKey) {
      /* shift + tab */ if (document.activeElement === firstFocusableNode) {
        lastFocusableNode.focus({ preventScroll: true })
        e.preventDefault()
      }
    } /* tab */ else {
      if (document.activeElement === lastFocusableNode) {
        firstFocusableNode.focus({ preventScroll: true })
        e.preventDefault()
      }
    }
  })

  return {
    firstNode: firstFocusableNode,
    lastNode: lastFocusableNode,
  }
}
